module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesNatural.4342184.jpg";